import styled from 'styled-components';
import { CSSVars } from '@/styles/styles.config';

export const StyledAnalyzerCta = styled.section`
  background: ${CSSVars.white};
  padding: 60px 20px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px 30px;
  }

  .analyzer-cta-inner {
    max-width: 1000px;
    margin: 0 auto;
    background: linear-gradient(135deg, #4c4fff 0%, #6b8cff 100%);
    border-radius: 20px;
    padding: 48px 32px;
    text-align: center;
    color: ${CSSVars.white};

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      padding: 64px 48px;
    }
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 10px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 34px;
    }
  }

  p {
    font-family: ${CSSVars.secondaryFont};
    font-weight: 300;
    font-size: 16px;
    margin: 0 auto 24px;
    max-width: 540px;
    opacity: 0.95;
  }

  .analyzer-cta-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 520px;
    margin: 0 auto;

    @media screen and (min-width: ${CSSVars.breakpointSM}) {
      flex-direction: row;
    }
  }

  .analyzer-cta-input {
    flex: 1;
    min-width: 0;
    padding: 14px 16px;
    font-size: 15px;
    font-family: ${CSSVars.primaryFont};
    color: ${CSSVars.black};
    background: ${CSSVars.white};
    border: none;
    border-radius: 10px;
    outline: none;
  }

  .analyzer-cta-btn {
    flex: 0 0 auto;
    padding: 14px 26px;
    font-size: 15px;
    font-weight: 600;
    font-family: ${CSSVars.primaryFont};
    color: ${CSSVars.blue500};
    background: ${CSSVars.white};
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    }
  }
`;
